/*eslint-disable */

import Vue from 'vue'
import axios from 'axios';
import root from '../_helpers/roots';

let inViewerListApiUrl = root.inViewerListApiUrl.link;
let inViewerCandidatesApiUrl = root.inViewerCandidatesApiUrl.link;
let qBankApiUrl = root.qBankApiUrl.link;
let qBankListApiUrl = root.qBankListApiUrl.link;
let questionApiUrl = root.questionApiUrl.link;
let ansOptionApiUrl = root.ansOptionApiUrl.link;
let questionBankCandidatesApiUrl = root.questionBankCandidatesApiUrl.link;
let getQueWithOptionInfoApiUrl = root.getQueWithOptionInfoApiUrl.link;
let getCadidateInfoWithQBankApiUrl = root.cadidateInfoWithQBankApiUrl.link;
let removeCandidateFromQbankApiUrl = root.removeCandidateFromQbankApiUrl.link;
let candidateContestHistoryApiUrl = root.candidateContestHistoryApiUrl.link;
let qbanksLinkToCandidateListForAdminApiUrl = root.qbanksLinkToCandidateListForAdminApiUrl.link;

export default {
  state: {
    inViewerListState:{},
    getInViewerCandidateListState:{},
    qBankListState:{},
    getQAnsListWithOptionState:{}
  },
  mutations: {
    inViewerListMutation(state, value) {
      Vue.set(state, 'inViewerListState', value);
    },
    getInViewerCandidateListMutation(state, value) {
      Vue.set(state, 'getInViewerCandidateListState', value);
    },
    qBankListMuatation(state, value) {
      Vue.set(state, 'qBankListState', value);
    },
    getQAnsListWithOptionMutation(state, value) {
      Vue.set(state, 'getQAnsListWithOptionState', value);
    },
  },
  actions: {
    // Get Qbanks Link To Candidate List For Admin Action
    getQbanksLinkToCandidateListForAdminAction(context, payload) {
      return new Promise((resolve, reject) => {
          axios.get(qbanksLinkToCandidateListForAdminApiUrl + payload.id + '/').then(res => {
            resolve(res);
          }).catch(err => {
            reject(err);
          })
      })
    },
    // Get Contest History API Action
    getContestHistoriesDataAction(context, payload) {
      return new Promise((resolve, reject) => {
          axios.get(candidateContestHistoryApiUrl + payload.data.ck + '/' + payload.data.qk + '/').then(res => {
            resolve(res);
          }).catch(err => {
            reject(err);
          })
      })
    },
    // Get Cadidate Info With Q Bank Action
    getCadidateInfoWithQBankAction(context, payload) {
      return new Promise((resolve, reject) => {
          axios.get(getCadidateInfoWithQBankApiUrl + payload.id + '/questionbanks-questions-options-with-answer/').then(res => {
            resolve(res);
          }).catch(err => {
            reject(err);
          })
      })
    },
    // Delete Q Bank API Action
    removeQBankFromCandiatesInfoByIdAction(context, payload) {
      return new Promise((resolve, reject) => {
          axios.delete(removeCandidateFromQbankApiUrl + payload.data.ck + '/' + payload.data.qk + '/').then(res => {
            resolve(res);
          }).catch(err => {
            reject(err);
          })
      })
    },
    // Post Q Bank API Action
    postQueBankWithCandiatesInfoAction(context, payload) {
      return new Promise((resolve, reject) => {
          axios.post(questionBankCandidatesApiUrl, payload).then(res => {
            resolve(res);
          }).catch(err => {
            reject(err);
          })
      })
    },
    // Get Q Bank API Action
    getQueBankWithCandiatesListAction(context, payload) {
      return new Promise((resolve, reject) => {
          axios.get(questionBankCandidatesApiUrl, payload).then(res => {
            resolve(res);
          }).catch(err => {
            reject(err);
          })
      })
    },
    // Post Q API Action
    postAnsOptionDataAction(context, payload) {
      return new Promise((resolve, reject) => {
          axios.post(ansOptionApiUrl, payload).then(res => {
            resolve(res);
          }).catch(err => {
            reject(err);
          })
      })
    },
    // Udpate Q API Action
    updateAnsOptionDataAction(context, payload) {
      return new Promise((resolve, reject) => {
          axios.patch(ansOptionApiUrl + payload.data.id + '/', payload.data.data).then(res => {
            resolve(res);
          }).catch(err => {
            reject(err);
          })
      })
    },
    // Remove Que By Id API Action
    removeQuestionByIdAction(context, payload) {
      return new Promise((resolve, reject) => {
          axios.delete(questionApiUrl + payload.id + '/').then(res => {
            resolve(res);
          }).catch(err => {
            reject(err);
          })
      })
    },
    // Get Que Detail By Id API Action
    getQuestionDetailByIdAction(context, payload) {
      return new Promise((resolve, reject) => {
          axios.get(getQueWithOptionInfoApiUrl + payload.id + '/options/').then(res => {
            resolve(res);
          }).catch(err => {
            reject(err);
          })
      })
    },
    // Update Q API Action
    updateQuestionDataAction(context, payload) {
      return new Promise((resolve, reject) => {
          axios.patch(questionApiUrl + payload.data.id + '/', payload.data.data).then(res => {
            resolve(res);
          }).catch(err => {
            reject(err);
          })
      })
    },
    // Post Q API Action
    postQuestionDataAction(context, payload) {
      return new Promise((resolve, reject) => {
          axios.post(questionApiUrl, payload).then(res => {
            resolve(res);
          }).catch(err => {
            reject(err);
          })
      })
    },
    // get All Q Ans List With Options API Action
    getQAnsListWithOptionAction(context, payload) {
      return new Promise((resolve, reject) => {
          axios.get(qBankListApiUrl + payload.id + '/questions-with-options/').then(res => {
            context.commit('getQAnsListWithOptionMutation', res.data);
            resolve(res);
          }).catch(err => {
            reject(err);
          })
      })
    },
    // Delete Q Bank API Action
    removeQBankInfoAction(context, payload) {
      return new Promise((resolve, reject) => {
          axios.delete(qBankApiUrl + payload.id + '/').then(res => {
            resolve(res);
          }).catch(err => {
            reject(err);
          })
      })
    },
    // Patch Q Bank API Action
    updateQBankInfoAction(context, payload) {
      return new Promise((resolve, reject) => {
          axios.patch(qBankApiUrl + payload.data.id + '/', payload.data.data).then(res => {
            resolve(res);
          }).catch(err => {
            reject(err);
          })
      })
    },
    // Post Q Bank API Action
    postQBankInfoAction(context, payload) {
      return new Promise((resolve, reject) => {
          axios.post(qBankApiUrl, payload).then(res => {
            resolve(res);
          }).catch(err => {
            reject(err);
          })
      })
    },
    // Get Q Bank API Action
    getQBankInfoAction(context, payload) {
      return new Promise((resolve, reject) => {
          axios.get(qBankApiUrl, payload).then(res => {
            context.commit('qBankListMuatation', res.data);
            resolve(res);
          }).catch(err => {
            reject(err);
          })
      })
    },
    // Get Q Bank Info By Id API Action
    getQBankInfoByIdAction(context, payload) {
      return new Promise((resolve, reject) => {
          axios.get(qBankApiUrl + payload.id + '/').then(res => {
            resolve(res);
          }).catch(err => {
            reject(err);
          })
      })
    },
    // Get Interview List Action
    inViewerListAction(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(inViewerListApiUrl).then(res => {
              context.commit('inViewerListMutation', res.data);
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Post Interview Info Action
    postInViewerInfoAction(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post(inViewerListApiUrl, payload).then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Post Interview Candidates Info Action
    postInViewerCandidateInfoAction(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post(inViewerCandidatesApiUrl, payload).then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Get Interview Candidates Info Action
    getInViewerCandidateListAction(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(inViewerCandidatesApiUrl).then(res => {
              context.commit('getInViewerCandidateListMutation', res.data);
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Get Interview Candidates Info By ID Action
    getInViewerCandidateInfoByIdAction(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(inViewerCandidatesApiUrl + payload.id + "/").then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Remove Interview Candidates Info Action
    removeInVCandidateInfoAction(context, payload) {
        return new Promise((resolve, reject) => {
            axios.delete(inViewerCandidatesApiUrl + payload.id + '/').then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Update Interview Candidates Info By ID Action
  updateInViewerCandidateInfoByIdAction(context, payload) {
        return new Promise((resolve, reject) => {
            axios.patch(inViewerCandidatesApiUrl + payload.data.id + "/", payload.data.data).then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
  },
  getters: {
    inViewerListGetter: state => state.inViewerListState,
    getInViewerCandidateListGetter: state => state.getInViewerCandidateListState,
    qBankListGetter: state => state.qBankListState,
    getQAnsListWithOptionGetter: state => state.getQAnsListWithOptionState
  }
}